import Burst from './background-burst.svg';
import ContinueButton from './button-continue.svg';
import BackToWorkshopButton from './button-back-workshop.svg';
import BulletCarrot from './bullet-carrot.svg';
import BulletCheck from './bullet-check.svg';
import DiamondCheckGreen from './diamond-check-green.svg';
import DiamondCheck from './diamond-check.svg';

import DiamondProgressBattery from './diamond-progress-battery.svg';
import DiamondProgressBook from './diamond-progress-book.svg';
import DiamondProgressPortal from './diamond-progress-portal.svg';
import DiamondProgressRadio from './diamond-progress-radio.svg';

import DiamondActiveBattery from './diamond-active-battery.svg';
import DiamondActiveBook from './diamond-active-book.svg';
import DiamondActivePortal from './diamond-active-portal.svg';
import DiamondActiveRadio from './diamond-active-radio.svg';

import DiamondProgressGreenBattery from './diamond-green-battery.svg';
import DiamondProgressGreenBook from './diamond-green-book.svg';
import DiamondProgressGreenPortal from './diamond-green-portal.svg';
import DiamondProgressGreenRadio from './diamond-green-radio.svg';

import DiamondInactiveBattery from './diamond-inactive-battery.svg';
import DiamondInactiveBook from './diamond-inactive-book.svg';
import DiamondInactivePortal from './diamond-inactive-portal.svg';
import DiamondInactiveRadio from './diamond-inactive-radio.svg';

import ProgressIconBattery from './battery.svg';
import MediumGreenPanel from './panel-green-medium.svg';
import MediumBrownPanel from './panel-brown-medium.svg';
import LargeBrownPanel from './large-brown-panel.svg';
import LargeParchmentPanel from './large-parchment-panel.svg';

import WideGreenPanel from './panel-green-wide.svg';

import CloseButton from './CloseIcon.svg';

import BatteryIconFilled from './successmodal_battery-fill.svg';
import BatteryIcon from './successmodal_battery.svg';

import RadioIconFilled from './successmodal_radio-fill.svg';
import RadioIcon from './successmodal_radio.svg';

import BookIconFilled from './successmodal_book-fill.svg';
import BookIcon from './successmodal_book.svg';

import PortalIconFilled from './successmodal_portal-fill.svg';
import PortalIcon from './successmodal_portal.svg';

export default {
  LargeBrownPanel,
  LargeParchmentPanel,
  DiamondProgressGreenBattery,
  DiamondProgressGreenBook,
  DiamondProgressGreenPortal,
  DiamondProgressGreenRadio,
  DiamondCheckGreen,
  WideGreenPanel,
  PortalIconFilled,
  PortalIcon,
  RadioIconFilled,
  RadioIcon,
  BookIconFilled,
  BookIcon,
  BatteryIconFilled,
  BatteryIcon,
  Burst,
  BulletCarrot,
  BulletCheck,
  DiamondCheck,
  ProgressIconBattery,
  DiamondProgressBattery,
  DiamondProgressBook,
  DiamondProgressPortal,
  DiamondProgressRadio,
  DiamondActiveBattery,
  DiamondActiveBook,
  DiamondActivePortal,
  DiamondActiveRadio,
  DiamondInactiveBattery,
  DiamondInactiveBook,
  DiamondInactivePortal,
  DiamondInactiveRadio,
  ContinueButton,
  CloseButton,
  BackToWorkshopButton,
  MediumGreenPanel,
  MediumBrownPanel,
};
